class SubcategoriaProducto
{
  idSubcategoriaProducto = 0;
  nombreSubcategoria = "";
  activo = true;
  idCategoriaProducto = 0;
  accion = "";
  fechahora = "";
  nombreCategoria = "";
  usuarios_idUsuario = 0;

  traducciones = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = SubcategoriaProducto;
